import styled from 'styled-components';

export const Container = styled.div`
  .list-tools {
    position: sticky;
    background: ${(props) => props.theme.$bg_gray};
    top: 3.8em;
    z-index: 12;

    @media (max-width: 992px) {
      top: 3em;
    }
  }

  .itemToolsSelected {
    bottom: 2px;
    font-size: 0.9rem;
    background-color: #007bff1a;
    padding: 15px 20px;
    border-radius: 4px;

    button {
      font-size: 1em;
      border: none;
      background-color: unset;
      box-shadow: none;
    }
  }

  .loading-bidding-list {
    height: calc(100vh - 56px);
  }

  &.result-container {
    transition: all 1s;
  }

  .remove-favorites {
    font-size: 13px;
    border-left: 1px solid #000;
    border-radius: unset;
    margin: 5px 0px;
    background-color: unset;
    box-shadow: none;
  }
`;
